export default "__VITE_ASSET__CgfDFX_q__"